module.exports = "/assets/data/24f81f982fec589879c6221fb7f03872-DN6.data.json";